import { dataService } from "../services/data.service";
import { SIGNOUT, SIGNIN, RESETPASSWORD, SET_EMAIL ,SET_USER} from "./mutation-types";

//const user = JSON.parse(localStorage.getItem("user"));
// const state = user
//   ? { status: { signedin: true, email:'' }, user }
//   : { status: { signedin: false, email:''}, user: null  };
const state = { 
  status: { 
    signedin: false, 
    Email: "" 
  }, 
  user: {}
};

const mutations = {
  [SIGNIN](state, user) {
    if (user) {
      state.status = { signedin: true };
      state.user = user;
    } else {
      state.status = { signedin: false };
      state.user = null;
    }
  },

  [SIGNOUT](state) {
    state.status = { signedin: false };
    state.user = null;
  },

  [RESETPASSWORD](state, username) {
    // state.status = {email : username};
    //state.email =  username;
    state.status = Object.assign({}, state.status, username);
  },

  [SET_EMAIL](state, username) {
    state.status = { signedin: false, Email: username };
    state.user = null;
  },
  [SET_USER](state, user) {
    state.user = Object.assign({}, state.user, user);
  },

  authenticateUser(state, authenticated) {
    state.status = { signedin: authenticated };
  }
};
const actions = {
  async signin({ commit, dispatch }, { username, password }) {
    try {
      const result = await dataService.signin(username, password);

      commit(SIGNIN, result);
      dispatch("users/setUser", result, { root: true });
    } catch (error) {
      console.log(error);
      commit(SIGNIN, null);
      dispatch("alert/error", dataService.errorResponseHandler(error), {
        root: true
      });
    }
  },

  async signout({ commit }) {
    await dataService.signout();
    commit(SIGNOUT);
  },
  async forgotPassword({ commit, dispatch }, { username }) {
    try {
      await dataService.forgotPassword(username);
      commit(RESETPASSWORD, username);
      return true;
    } catch (error) {
      dispatch("alert/error", dataService.errorResponseHandler(error), {
        root: true
      }).then(() => {
        return false;
      });
      return false;
    }
  },
  async resetPassword({ commit, dispatch }, { password, key }) {
    try {
      const result = await dataService.resetPassword(password, key);
      commit(RESETPASSWORD, result);
      return true;
    } catch (error) {
      dispatch("alert/error", dataService.errorResponseHandler(error), {
        root: true
      }).then(() => {
        return false;
      });
      return false;
    }
  },
  async getUsername({ commit }, { key }) {
    try {
      const result = await dataService.getUsername(key);
      commit(SET_EMAIL, result);
      return result;
    } catch (error) {
      return "";
    }
  },
  async authenticateUserAction({ commit }) {
    try {
      const result = await dataService.authenticateUser();
      commit('authenticateUser', result.data);
      return result;
    } catch (error) {
      return "";
    }
  },
  
};
const getters = {
  isLoggedin: state => {
    return state.status.signedin;
  },
  getFirstName: state => state.user.FirstName
};

export const account = {
  namespaced: true,
  state,
  mutations,
  actions ,
   getters
};
